import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const serviceTypeLocaleModule: LocaleModule = {
  name: "serviceType",
  messages: { en: en, it: it },
};
